// Subcategory Dropdown on collection page
  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.subcategory-dropdown__toggle');

    if (!toggle) return;

    toggle.addEventListener('click', function () {
      toggle.closest('.subcategory-dropdown').classList.toggle('is-open');
    });
  });

  // Marquee on our products start here
document.addEventListener('DOMContentLoaded', () => {
  // console.log("Init carousel");
setTimeout(() => {
// 
  const carousels = document.querySelectorAll('.js-product-carousel');
  console.log("carousels",carousels)
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    waitForFlickity(carousel);
  });
}, 4000);
  /**
   * Polls for Flickity on the carousel element (and its first child as fallback).
   * If Flickity never self-initializes within maxAttempts, we init it ourselves.
   */
  function waitForFlickity(carousel, maxAttempts = 30, interval = 200) {
    let attempts = 0;

    const check = setInterval(() => {
      attempts++;
      // console.log("attempts",attempts)

      // Try the element itself, then its first child (Flickity sometimes attaches to inner wrapper)
      const flkty =
        (window.Flickity && Flickity.data(carousel)) ||
        (window.Flickity && carousel.firstElementChild && Flickity.data(carousel.firstElementChild));

      if (flkty) {
        clearInterval(check);
        // console.log("Flickity found on attempt", attempts, carousel);
        initMarquee(carousel, flkty);
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(check);
        // console.warn("Flickity never self-initialized — initializing manually on", carousel);

        if (!window.Flickity) {
          // console.error("Flickity is not loaded at all.");
          return;
        }

        // Fallback: initialize Flickity ourselves
        const flktyFallback = new Flickity(carousel, {
          wrapAround: true,
          draggable: true,
          prevNextButtons: true,
          pageDots: false,
          cellAlign: 'left',
          contain: true,
          freeScroll: true,
        });

        initMarquee(carousel, flktyFallback);
      }
    }, interval);
  }

  /**
   * Sets up the infinite marquee effect on a Flickity instance.
   */
  function initMarquee(carousel, flkty) {
    // 1) Force wrapAround
    flkty.options.wrapAround = true;

    // 2) Get the slider element
    const slider = carousel.querySelector('.flickity-slider');
    if (!slider) {
      console.warn("No .flickity-slider found inside", carousel);
      return;
    }

    // 3) Clone cells until there are enough to fill 2x the viewport width
    function ensureEnoughCells() {
      flkty.reloadCells();
      flkty.resize();

      let cells = flkty.cells;
      const viewportWidth = flkty.size.innerWidth;

      let totalWidth = cells.reduce((sum, cell) => sum + cell.size.outerWidth, 0);

      // Safety cap to prevent infinite loop
      let safetyLimit = 10;

      while (totalWidth < viewportWidth * 2 && safetyLimit > 0) {
        safetyLimit--;

        // Clone only ORIGINAL cells (not already-cloned ones) to avoid exponential growth
        const originalCells = Array.from(slider.children).filter(
          (el) => !el.classList.contains('is-clone')
        );

        originalCells.forEach((cell) => {
          const clone = cell.cloneNode(true);
          clone.classList.add('is-clone');
          slider.appendChild(clone);
        });

        flkty.reloadCells();
        flkty.resize();

        cells = flkty.cells;
        totalWidth = cells.reduce((sum, cell) => sum + cell.size.outerWidth, 0);
      }

      if (safetyLimit === 0) {
        console.warn("ensureEnoughCells hit safety limit — check cell widths.");
      }
    }

    ensureEnoughCells();

    // 4) Marquee animation
    const speed = window.innerWidth < 768 ? 0.25 : 0.4;
    let rafId;
    let isPaused = false;

    function marquee() {
      if (isPaused) return;

      flkty.x -= speed;

      // Reset when we've scrolled past the full slideable width
      if (Math.abs(flkty.x) >= flkty.slideableWidth) {
        flkty.x = 0;
      }

      flkty.settle(flkty.x);
      rafId = requestAnimationFrame(marquee);
    }

    marquee();

    // 5) Pause on hover
    carousel.addEventListener('mouseenter', () => {
      isPaused = true;
      cancelAnimationFrame(rafId);
    });

    carousel.addEventListener('mouseleave', () => {
      isPaused = false;
      marquee();
    });

    // 6) Handle page visibility (pause when tab is hidden)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        isPaused = true;
        cancelAnimationFrame(rafId);
      } else {
        isPaused = false;
        marquee();
      }
    });
  }
});

// Mobile Menu

  document.querySelectorAll('.custom_menu_toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
      const content = btn.nextElementSibling;
      content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });
  });

  function closeMobileMenu() {
    document.querySelector('.custom_mobile_menu').style.display = 'none';
  }

//Quantity on cart drawer 

document.addEventListener('click', e => {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;

  const wrap = btn.closest('.quantity-wrapper');
  const input = wrap.querySelector('.qty-input');
  const key = wrap.dataset.lineKey;

  let qty = parseInt(input.value, 10) || 1;
  qty += btn.classList.contains('plus') ? 1 : -1;
  qty = Math.max(1, qty);
  input.value = qty;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(cart =>
    document.dispatchEvent(
      new CustomEvent('cart:updated', { detail: cart })
    )
  )
  .catch(console.error);
});

document.addEventListener('cart:updated', e => {
  if (e.detail?.item_count !== undefined) {
    updateCartBubble(e.detail.item_count);
  } else {
    fetch('/cart.js')
      .then(r => r.json())
      .then(c => updateCartBubble(c.item_count));
  }
});

function updateCartBubble(count) {
  document.querySelectorAll('.count-bubble span').forEach(b => {
    b.textContent = count || '';
    b.classList.toggle('hidden', !count);
  });
}
